import backboneApi from './backboneApi';

export function callBackbonePostApi(payload, url = '', config = {}) {
  return backboneApi.post(url, payload, config);
}
